import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

export default function Home() {
  const router = useRouter();
  const alerted = useRef(false);

  useEffect(() => {
    if (alerted.current) {
      return;
    }

    alert('해당 코스는 현재 모집이 종료되었습니다.');
    alerted.current = true;
    router.push('/');
  }, [router]);

  return <></>;
}
